import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { LogOutIcon, PlusIcon } from "components/atoms/Icon";
import { Button } from "components/atoms/Button";
import posthog from "posthog-js";
import HoverableDropdown from "components/atoms/HoverableDropdown/HoverableDropdown";
import { useUpdateActiveOrganization } from "mutations/useUpdateActiveOrganization";
import CreateOrganizationModal from "components/molecules/CreateOrganizationModal/CreateOrganizationModal";
import { usePermissions } from "hooks/usePermissions";
import { UserPermissions } from "utils/enums";
import { Paragraph } from "../../atoms/Typography";
import styles from "./HeaderDropDownMenu.module.scss";

interface HeaderDropdownMenuProps {
    userEmail: string;
    customerAccounts: BriefCustomerAccount[];
    activeOrganizationName: string;
}

function HeaderDropdownMenu({ userEmail, customerAccounts, activeOrganizationName }: HeaderDropdownMenuProps) {
    const { logout } = useAuth0();
    const { mutate } = useUpdateActiveOrganization();

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const { hasPermission } = usePermissions();

    const handleOrganizationChange = (newActiveOrganizationUid: string) => {
        const newActiveOrganizationUidObject = {
            activeOrganizationUid: newActiveOrganizationUid,
        };
        mutate(newActiveOrganizationUidObject);
    };

    const handleNewOrganization = () => {
        setModalIsOpen(true);
    };

    const handleCancel = () => {
        setModalIsOpen(false);
    };

    return (
        <div>
            <HoverableDropdown
                userEmail={userEmail ? userEmail[0].toUpperCase() : ""}
                customerAccounts={customerAccounts}
                activeOrganizationName={activeOrganizationName}
                dropdownElements={
                    <>
                        {customerAccounts
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((customerAccount, index) => (
                                <Button
                                    className={`
                                                headerButton 
                                                headerCustomerAccount
                                                ${
                                                    customerAccount.name === activeOrganizationName
                                                        ? // eslint-disable-next-line
                                                          styles.headerActiveCustomerAccountContainer
                                                        : ""
                                                }
                                                ${index === customerAccounts.length - 1 ? "headerCustomerAccountLast" : ""}    
                                            `}
                                    key={customerAccount.customerAccountUid}
                                    onClick={() => handleOrganizationChange(customerAccount.customerAccountUid)}
                                >
                                    <span>{customerAccount.name}</span>
                                    {customerAccount.name === activeOrganizationName && (
                                        <span className={styles.headerActiveCustomerAccount}>Signed In</span>
                                    )}
                                </Button>
                            ))}

                        {hasPermission(UserPermissions.CreateCustomerAccount) && (
                            <Button
                                id="nav-bar-sign-out-button"
                                className="headerButton"
                                onClick={handleNewOrganization}
                            >
                                <Paragraph className="logOutContainer">
                                    <PlusIcon />
                                    New organization
                                </Paragraph>
                            </Button>
                        )}

                        <Button
                            id="nav-bar-sign-out-button"
                            onClick={() => {
                                logout({
                                    returnTo: window.location.origin,
                                });
                                posthog.capture("User signed out");
                            }}
                            className="headerButton"
                        >
                            <Paragraph className="logOutContainer">
                                <LogOutIcon />
                                Sign Out
                            </Paragraph>
                        </Button>
                    </>
                }
            />
            <CreateOrganizationModal
                modalIsOpen={modalIsOpen}
                onCancel={handleCancel}
                setModalIsOpen={setModalIsOpen}
            />
        </div>
    );
}

export default HeaderDropdownMenu;
